/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {
  AR_SUMRY_BY_MFG_ROUTE,
  AR_SUMRY_BY_QTR_ROUTE,
  AR_SUMRY_MFG_ALL,
  MANU_AR_ROUTE,
  AR_SUMRY_BY_QTR_ALL_ROUTE,
  AR_SUMRY_BY_QTR_ACCOUNT_SINGLE_ROUTE,
  AR_SUMRY_BY_QTR_ACCOUNT_ALL_ROUTE,
  AR_MANUFACTURER_ROUTE,
  AR_SUMRY_BY_ACCOUNT_NDC_ALL_ROUTE,
  AR_SUMRY_BY_ACCOUNT_NDC_SINGLE_ROUTE,
  AR_ACCOUNT_NDC_ACTIVITY_ROUTE,
} from './AccountsRevConstants';
import * as serviceEndPoint from '../../../SharedModules/services/service';
import { clearReduxForFilterAndSort } from '../../../SharedModules/Table/store/Actions';

export const goToArSummaryMfg = (history, rebate_pgm, dispatch) => {
  let navTo = `/arSummaryByMfg/${uuidv4()}`;
  dispatch(clearReduxForFilterAndSort(navTo));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    updateTabs?.some((ob) => ob.value === `AR Summary By Mfg [${rebate_pgm}]`)
  ) {
    navTo = updateTabs.filter((ob) => {
      return ob.value === `AR Summary By Mfg [${rebate_pgm}]`;
    })[0]?.navTo;
  }
  if (!updateTabs?.some((ob) => ob.navTo === navTo)) {
    updateTabs.push({
      navTo: navTo,
      value: `AR Summary By Mfg [${rebate_pgm}]`,
      state: { mfgId: null, rebateProgram: rebate_pgm },
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    const arSmryQtr = updateTabs.filter((ob) => ob.navTo === navTo)[0];
    arSmryQtr.value = `AR Summary By Mfg [${rebate_pgm}]`;
    const record = [
      ...updateTabs.filter((ob) => ob.navTo !== navTo),
      arSmryQtr,
    ];
    localStorage.setItem('tabItemsData', JSON.stringify(record));
  }
  history.push({
    pathname: navTo,
    state: { mfgId: null, rebateProgram: rebate_pgm },
  });
};

export const gotoArSummaryMfgAll = (history, dispatch) => {
  dispatch(clearReduxForFilterAndSort(AR_SUMRY_MFG_ALL));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (!updateTabs.some((ob) => ob.navTo === AR_SUMRY_MFG_ALL)) {
    updateTabs.push({
      navTo: AR_SUMRY_MFG_ALL,
      value: 'AR Summary By Mfg',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  history.push({ pathname: AR_SUMRY_MFG_ALL });
  // localStorage.setItem('arsummarybymfgall', 'true');
};

export const goToArSummaryQtr = (history, rebate_pgm, dispatch) => {
  let navTo = `/ARSummaryByQtr/${uuidv4()}`;
  dispatch(clearReduxForFilterAndSort(navTo));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    updateTabs?.some((ob) => ob.value === `AR Summary By Qtr [${rebate_pgm}]`)
  ) {
    navTo = updateTabs.filter((ob) => {
      return ob.value === `AR Summary By Qtr [${rebate_pgm}]`;
    })[0]?.navTo;
  }
  if (!updateTabs.some((ob) => ob.navTo === navTo)) {
    updateTabs.push({
      navTo: navTo,
      value: `AR Summary By Qtr [${rebate_pgm}]`,
      state: { mfgId: null, rebateProgram: rebate_pgm },
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    const arSmryQtr = updateTabs.filter((ob) => ob.navTo === navTo)[0];
    arSmryQtr.value = `AR Summary By Qtr [${rebate_pgm}]`;
    const record = [
      ...updateTabs.filter((ob) => ob.navTo !== navTo),
      arSmryQtr,
    ];
    localStorage.setItem('tabItemsData', JSON.stringify(record));
  }
  history.push({
    pathname: navTo,
    state: { mfgId: null, rebateProgram: rebate_pgm },
  });
};

export const gotoArSummaryQtrAll = (history, dispatch) => {
  dispatch(clearReduxForFilterAndSort(AR_SUMRY_BY_QTR_ALL_ROUTE));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (!updateTabs.some((ob) => ob.navTo === AR_SUMRY_BY_QTR_ALL_ROUTE)) {
    updateTabs.push({
      navTo: AR_SUMRY_BY_QTR_ALL_ROUTE,
      value: 'AR Summary By Qtr',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  history.push({ pathname: AR_SUMRY_BY_QTR_ALL_ROUTE });
  // localStorage.setItem('arsummarybyqtrall', 'true');
};

export const goToMfgAccRec = (history, dispatch, data) => {
  let navTo = `/mfgAccountRec/${uuidv4()}`;
  dispatch(clearReduxForFilterAndSort(navTo));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    updateTabs?.some(
      (ob) =>
        ob.value ===
        `Manufacturer Accounts Receivable [${data?.mfgId}-${
          data?.rebateProgram ? data?.rebateProgram : 'All'
        }]`
    )
  ) {
    navTo = updateTabs.filter((ob) => {
      return (
        ob.value ===
        `Manufacturer Accounts Receivable [${data?.mfgId}-${
          data?.rebateProgram ? data?.rebateProgram : 'All'
        }]`
      );
    })[0]?.navTo;
  }
  if (!updateTabs.some((ob) => ob.navTo === navTo)) {
    updateTabs.push({
      navTo: navTo,
      value: `Manufacturer Accounts Receivable [${data?.mfgId}-${
        data?.rebateProgram ? data?.rebateProgram : 'All'
      }]`,
      state: {
        mfgId: data?.mfgId,
        rebateProgram: data?.rebateProgram ? data?.rebateProgram : 'All',
      },
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    const arSmryQtr = updateTabs.filter((ob) => ob.navTo === navTo)[0];
    arSmryQtr.value = `Manufacturer Accounts Receivable [${data?.mfgId}-${
      data?.rebateProgram ? data?.rebateProgram : 'All'
    }]`;
    const record = [
      ...updateTabs.filter((ob) => ob.navTo !== navTo),
      arSmryQtr,
    ];
    localStorage.setItem('tabItemsData', JSON.stringify(record));
  }
  history.push({
    pathname: navTo,
    state: {
      mfgId: data?.mfgId,
      rebateProgram: data?.rebateProgram ? data?.rebateProgram : 'All',
    },
  });
  // localStorage.setItem('mfgAccRec', 'true');
};

export const goToArMfg = (history, rebate_pgm, dispatch) => {
  dispatch(clearReduxForFilterAndSort(AR_MANUFACTURER_ROUTE));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (!updateTabs.some((ob) => ob.navTo === AR_MANUFACTURER_ROUTE)) {
    updateTabs.push({
      navTo: AR_MANUFACTURER_ROUTE,
      value: `AR Manufacturer [${rebate_pgm}]`,
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    const arSmryQtr = updateTabs.filter(
      (ob) => ob.navTo === AR_MANUFACTURER_ROUTE
    )[0];
    arSmryQtr.value = `AR Manufacturer [${rebate_pgm}]`;
    const record = [
      ...updateTabs.filter((ob) => ob.navTo !== AR_MANUFACTURER_ROUTE),
      arSmryQtr,
    ];
    localStorage.setItem('tabItemsData', JSON.stringify(record));
  }
  history.push({ pathname: AR_MANUFACTURER_ROUTE });
  // localStorage.setItem('arManufatcurer', 'true');
};

export const getExistingCorrLinkIds = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, { corrLinkId: value })
    .then((response) => {
      return response.data.data;
    })
    .catch(() => {
      return [];
    });
};

export const getInvoiceDetailByInvoiceNum = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, values)
    .then((response) => {
      return response.data;
    });
};

export const getMfgBankruptcyCounts = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_BNKRUPT_CNT, values)
    .then((response) => {
      return response.data;
    });
};

export const displayChecklist = (values) => (dispatch) => {
  const payload = {
    checkLogNum: values,
    batchNum: null,
    checkNum: null,
    disputeResolutionCd: null,
    notDrugRebateInd: null,
    checkIdentifier: null,
    checkPayeeCd: null,
    lastUpdateUserId: null,
    checkIssuer: null,
    checkInfo: null,
    paymentMediaTypeCd: null,
    invRecFormatCd: null,
    checkDt: null,
    toCheckDt: null,
    suspendedDt: null,
    toSuspendedDt: null,
    postmarkedDt: null,
    toPostmarkedDt: null,
    batchDt: null,
    toBatchDt: null,
    receivedDt: null,
    toReceivedDt: null,
  };
  return axios
    .post(`${serviceEndPoint.SEARCH_CHECK_RESULTS}`, payload)
    .then((response) => {
      return response.data.data;
    })
    .catch((response) => {});
};

export const getManuARForAllRpcNavFn = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_SINGLE_ALL}`, val)
    .then((response) => {
      return response.data;
    })
    .catch((response) => response.data);
};

export const getManuARForSglRpcNavFn = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_SINGLE_SIGNLE}`, val)
    .then((response) => {
      return response.data;
    })
    .catch((response) => response.data);
};

export const updateBankruptMfg = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.UPT_MANU_BANKRUPT}`, val)
    .then((response) => {
      return response.data;
    })
    .catch((response) => response.data);
};

export const getContractDetail = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CTRT_INFO_LIST}`, { contractSeqNumList: val })
    .then((response) => {
      return response.data;
    })
    .catch((response) => response.data);
};

export const getContractSeqList = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CTRT_SEQ_NUMS}`, val)
    .then(async (response) => {
      const payload = response.data.contractSeqNumList.map(
        (obj) => obj.contractSeqNum
      );
      if (payload.length === 0) return response.data;
      const result = await dispatch(getContractDetail(payload));
      return result;
    })
    .catch((response) => response.data);
};

export const undoBankruptMfg = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.UNDO_MANU_BANKRUPT}`, val)
    .then((response) => {
      return response.data;
    })
    .catch((response) => response.data);
};

export const getInvoiceDetails = (value) => {
  return axios
    .post(serviceEndPoint.GET_INV_HEADER, { invoiceNum: value })
    .then((response) => {
      if (response.data?.status === '001' && response.data?.invoiceHeaderVo)
        return response.data?.invoiceHeaderVo;
      return false;
    })
    .catch(() => {
      return false;
    });
};

export const getDrugQtrDetails = (data) => {
  return axios
    .post(serviceEndPoint.GET_DRUG_QTR_UNIT_AR, data)
    .then((response) => {
      if (response.data?.status === '001' && response.data?.drugQtrDetailsVO)
        return response.data?.drugQtrDetailsVO;
      return false;
    })
    .catch(() => {
      return false;
    });
};

export const goToArSummaryQtrAccountSingle = (history, pgm, dispatch) => {
  let navTo = `/QtrAccountsRec/${uuidv4()}`;
  dispatch(clearReduxForFilterAndSort(navTo));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    updateTabs?.some(
      (ob) => ob.value === `Quarterly Accounts Receivable [${pgm}]`
    )
  ) {
    navTo = updateTabs.filter((ob) => {
      return ob.value === `Quarterly Accounts Receivable [${pgm}]`;
    })[0]?.navTo;
  }
  if (!updateTabs.some((ob) => ob.navTo === navTo)) {
    updateTabs.push({
      navTo: navTo,
      value: `Quarterly Accounts Receivable [${pgm}]`,
      state: { mfgId: null, rebateProgram: pgm },
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    const arSmryQtr = updateTabs.filter((ob) => ob.navTo === navTo)[0];
    arSmryQtr.value = `Quarterly Accounts Receivable [${pgm}]`;
    const record = [
      ...updateTabs.filter((ob) => ob.navTo !== navTo),
      arSmryQtr,
    ];
    localStorage.setItem('tabItemsData', JSON.stringify(record));
  }
  history.push({ pathname: navTo, state: { mfgId: null, rebateProgram: pgm } });
};
export const goToArSummaryQtrAccountAll = (history, dispatch) => {
  dispatch(clearReduxForFilterAndSort(AR_SUMRY_BY_QTR_ACCOUNT_ALL_ROUTE));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    !updateTabs.some((ob) => ob.navTo === AR_SUMRY_BY_QTR_ACCOUNT_ALL_ROUTE)
  ) {
    updateTabs.push({
      navTo: AR_SUMRY_BY_QTR_ACCOUNT_ALL_ROUTE,
      value: 'Quarterly Accounts Receivable',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  history.push({ pathname: AR_SUMRY_BY_QTR_ACCOUNT_ALL_ROUTE });
  localStorage.setItem('arsummarybyqtraccountall', 'true');
};
export const goToArSummaryAccRecNDCAll = (history, dispatch) => {
  dispatch(clearReduxForFilterAndSort(AR_SUMRY_BY_ACCOUNT_NDC_ALL_ROUTE));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    !updateTabs.some((ob) => ob.navTo === AR_SUMRY_BY_ACCOUNT_NDC_ALL_ROUTE)
  ) {
    updateTabs.push({
      navTo: AR_SUMRY_BY_ACCOUNT_NDC_ALL_ROUTE,
      value: 'Accounts Receivable NDC Detail',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  history.push({ pathname: AR_SUMRY_BY_ACCOUNT_NDC_ALL_ROUTE });
  localStorage.setItem('arsummarybyaccountndcall', 'true');
};

export const goToArSummaryAccRecNDCSingle = (history, pgm, dispatch) => {
  let navTo = `/AccRecNDCDetail/${uuidv4()}`;

  dispatch(clearReduxForFilterAndSort(navTo));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    updateTabs?.some(
      (ob) => ob.value === `Accounts Receivable NDC Detail [${pgm}]`
    )
  ) {
    navTo = updateTabs.filter((ob) => {
      return ob.value === `Accounts Receivable NDC Detail [${pgm}]`;
    })[0]?.navTo;
  }
  if (!updateTabs.some((ob) => ob.navTo === navTo)) {
    updateTabs.push({
      navTo: navTo,
      value: `Accounts Receivable NDC Detail [${pgm}]`,
      state: { mfgId: null, rebateProgram: pgm },
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  } else {
    const arSmryQtr = updateTabs.filter((ob) => ob.navTo === navTo)[0];
    arSmryQtr.value = `Accounts Receivable NDC Detail [${pgm}]`;
    const record = [
      ...updateTabs.filter((ob) => ob.navTo !== navTo),
      arSmryQtr,
    ];
    localStorage.setItem('tabItemsData', JSON.stringify(record));
  }
  history.push({ pathname: navTo, state: { mfgId: null, rebateProgram: pgm } });
  // localStorage.setItem('arsummarybyaccountndcsingle', 'true');
};

export const updateInvoiceBalanced = (values) => {
  return axios
    .post(`${serviceEndPoint.UPDATE_INV_BAL}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const undoInvoiceBalanced = (values) => {
  return axios
    .post(`${serviceEndPoint.UNDO_INV_BALANCED}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const updateInvoiceBankrupt = (values) => {
  return axios
    .post(`${serviceEndPoint.UPT_INV_BANKRUPT}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const undoInvoiceBankrupt = (values) => {
  return axios
    .post(`${serviceEndPoint.UNDO_INV_BANKRUPT}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const goToNDCActivity = (history, dispatch) => {
  dispatch(clearReduxForFilterAndSort(AR_ACCOUNT_NDC_ACTIVITY_ROUTE));
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  if (!updateTabs.some((ob) => ob.navTo === AR_ACCOUNT_NDC_ACTIVITY_ROUTE)) {
    updateTabs.push({
      navTo: AR_ACCOUNT_NDC_ACTIVITY_ROUTE,
      value: 'Accounts Receivable NDC Activity',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  history.push({ pathname: AR_ACCOUNT_NDC_ACTIVITY_ROUTE });
  // localStorage.setItem('NDCActivitySet', 'true');
};

export const declareNDCBalanced = (values) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_DECLARE_NDC_BAL}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const undoDeclareNDCBalanced = (values) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_UNDO_DECLARE_NDC_BAL}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const modifyUnitsFromAcctRecv = (values) => {
  return axios
    .post(`${serviceEndPoint.MODIFY_UNIT_AR}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};

export const overrideInterestFromAR = (values) => {
  return axios
    .post(`${serviceEndPoint.OVRIDE_INT_AR}`, values)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return null;
    });
};
